<template>
  <div class="table-stats">
      <v-progress-linear
        v-if="loading"
        indeterminate
        :color="enterpriseColor"
      />
      <div style="padding: 0 10px;">
        <v-select
          v-model="selectedDateFilter"
          :items="datesFilter"
          :label="$t('dashboard.stats.month')"
          item-text="Name"
          item-value="ID"
          hide-details
          dense
        />
      </div>
      <v-simple-table v-if="dates">
      <thead>
        <tr>
          <th class="text-left" style="font-weight:300">{{ $t('dashboard.stats.menu') }}</th>
          <th class="text-center" style="font-weight:300">{{ $t('dashboard.stats.clicks') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in dates" :key="item.ID" style="padding-top:5px;">
          <td class="text-left">{{ item.Name }}</td>
          <td class="text-center">{{ item.Clicks }}</td>
        </tr>
      </tbody>
    </v-simple-table>
    <click-export 
      v-if="dataToExcel"
      :data="dataToExcel"
    />
  </div>
</template>
<script>
  import i18n from '@/plugins/i18n'
  import _ from 'lodash'
  import api from '@/services/api'
  import utils from '@/services/utils'
  import ClickExport from './ClickExport'
  export default {
    components: {
      ClickExport,
    },
    props: {
      enterpriseID: {
        type: String,
        required: true
      },
    },
    data: () => ({
      loading: false,
      key: 0,
      menus: null,
      dates: null,
      dataToExcel: null,
      datesFilter: [],
      selectedDateFilter: null,
    }),
    computed: {
      locale () {
        return i18n.locale
      },
      enterpriseColor() {
        return this.$store.state.app.enterpriseColor
      },
    },
    watch: {
      'enterpriseID': {
        handler: function (newValue) {
          this.handleGetMenus(newValue)
        },
        deep: true
      },
      selectedDateFilter () {
        this.handleGetMenus(this.enterpriseID)
      }
    },
    mounted () {
      const aux = [{ ID: null, Name: 'Todos' }]
      for (let i = 0 ; i < 12 ; i ++) {
        const today = new Date()
        let date = new Date(today.setMonth(today.getMonth() - i))
        const options = {year: 'numeric', month: 'long'}
        aux.push({
          ID: i,
          Name: date.toLocaleDateString('es', options)
        })
      }
      this.datesFilter = aux
      this.handleGetMenus(this.enterpriseID)
    },
    methods: {
      handleGetMenus(enterpriseID) {
        this.loading = true
        api.getAll(`stats/${enterpriseID}/menus/${this.selectedDateFilter >= 0 ? this.selectedDateFilter : ''}`, 1, 10000).then(response => {
          if(response)this.handleConvertMenus(response)
          this.loading = false
        }).catch((error) => {
          this.loading = false
        })
      },
      handleConvertMenus (menus) {
        const aux = menus.map(item => {
          return ({
            ID: item.ID,
            Name: item.ParentID ? utils.getTranslation(JSON.parse(item.ParentName), this.locale).concat(' / ', utils.getTranslation(JSON.parse(item.Name), this.locale)) : utils.getTranslation(JSON.parse(item.Name), this.locale),
            Clicks: item.Clicks
          })
        })
        this.dates = aux
        this.dataToExcel = menus.map(item => {
          return {
            MENUS: item.ParentID ? utils.getTranslation(JSON.parse(item.ParentName), this.locale) : utils.getTranslation(JSON.parse(item.Name), this.locale),
            SUBMENUS: item.ParentID ? utils.getTranslation(JSON.parse(item.Name), this.locale) : '',
            CLICKS: item.Clicks,
          }
        })
        this.loading = false
      },
    }
  }
</script>
<style>
  .table-stats td {
    vertical-align: middle !important;
  }
  .v-sheet--offset {
    top: -24px;
    position: relative;
  }
</style>
